import {
  Component, OnInit,
  Directive,
  ElementRef,
  Input,
} from '@angular/core';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { IExpiryMaster, Expiry_Model } from '../../interface/Expiry_Master'
import { DataService } from '../../../shared/services/data.service';
import { DatePipe } from '@angular/common';

export interface ExpiryModel {
  title: string;
  data: any;
}
@Component({
  selector: 'app-expiry-edit',
  templateUrl: './expiry-edit.component.html',
  styleUrls: ['./expiry-edit.component.css']
})

export class ExpiryEditComponent extends DialogComponent<ExpiryModel, boolean> implements ExpiryModel, OnInit {
  title: string;
  data: any = []
  fullData: any;
  expiryModel: IExpiryMaster
  result: any = { result: false, RtnItem: {} };
  constructor(dialogService: DialogService, private ds: DataService, public datepipe: DatePipe) { super(dialogService); }

  ngOnInit() {
    this.clear()
    this.expiryModel = this.data
    var newdate = this.datepipe.transform(new Date(this.expiryModel.ExpiryDate), 'yyyy-MM-dd');
    this.expiryModel.BatchNo = newdate.toString().replace(/-/g, "");
  }
  ok() {
    if (this.expiryModel.BatchNo == "" || this.expiryModel.BatchNo == null) {
      alert("Invalid Batch Number")
      document.getElementById("batchno").focus()
    }

    else {
      this.result.result = this.expiryModel
      this.close()
    }
  }

  batchNoKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {

      this.batchNoLeave();
    }
  }
  
  batchNoLeave() {
    // document.getElementById("expirydate").focus()
  }

  clear() {
    this.expiryModel = new Expiry_Model()
    this.expiryModel.ExpiryDate = new Date();
    document.getElementById("expirydate").focus()
  }

  expirydateLeave() {
    var newdate = this.datepipe.transform(new Date(this.expiryModel.ExpiryDate), 'yyyy-MM-dd');
    this.expiryModel.BatchNo = newdate.toString().replace(/-/g, "");
    document.getElementById("batchno").focus()
  }

  expirydateKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.expirydateLeave();
    }
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/expiry-edit/expiry-edit.component.ts